<template>
    
</template>

<script>
export default {
    data() {
        return {
            loadedInit: false,
            loaded: false,
            intervalInit: null,
            interval: null
        }
    },
    methods: {
        init() {
            let _this = this
                
            _this.intervalInit = setInterval(() => {
                if (document.querySelectorAll('.cke_button__image ').length && !_this.loadedInit) {
                    _this.loadedInit = true
                    let ckImgButton = document.querySelector('.cke_button__image ')
                    console.log(ckImgButton)
                    ckImgButton.addEventListener('click', function() {
                        _this.interval = setInterval(() => {
                            if (document.querySelectorAll('.cke_dialog_tabs').length && !_this.loaded) {
                                _this.loaded = true
                                let ckImgTabs = document.querySelectorAll('.cke_dialog_tabs')[document.querySelectorAll('.cke_dialog_tabs').length - 1]
                                let ckDialogBody = document.querySelectorAll('.cke_dialog_body')[document.querySelectorAll('.cke_dialog_body').length - 1]
                                let urlFieldLabel = document.querySelectorAll('.cke_dialog_ui_labeled_label')

                                let ckImgInput = document.querySelector('.ck_image_class')
                                
                                if (ckImgInput != null) {
                                    ckDialogBody.insertBefore(ckImgInput, ckImgTabs.nextSibling)
                                } else {
                                    ckImgInput = document.createElement('input')
                                    ckImgInput.setAttribute('type', 'file')
                                    ckImgInput.classList.add('ck_image_class')
                                    ckImgInput = ckDialogBody.insertBefore(ckImgInput, ckImgTabs.nextSibling)
                                }

                                ckImgInput.addEventListener('change', function(e) {
                                    let file = e.target.files[0]
                                    let fileData
                                    if (file) {
                                        let reader = new FileReader()
                                        let self = this
                                        reader.onload = function(event) {
                                            fileData = event.target.result
                                        }
                                        reader.readAsDataURL(file)

                                        let data = new FormData();
                                        data.append('file', file);
                                        let useCase = '?use_case=cover';
                                        _this.$http.post('/api/uploadfile' + useCase, data).then((response) => {
                                            for(let i = 0; i < urlFieldLabel.length; i++) {
                                                if (urlFieldLabel[i].textContent == 'URL') {
                                                    urlFieldLabel[i].parentElement.querySelector('input').value = `${_this.$store.state.apiDomain}/${response.data.url}`
                                                    ckImgInput.value = ''
                                                }
                                            }
                                        }).catch(error => {
                                            console.log(error)
                                        })


                                    }
                                })
                                clearInterval(_this.interval)
                            }
                        }, 100)
                    })
                    clearInterval(_this.intervalInit)
                }
            }, 100)
        }
    },
    mounted() {
        this.$nextTick((to1, from1) => {
            this.init()
        })
    }
}
</script>



// WEBPACK FOOTER //
// src/components/edit-form/AddImage.vue